
import moment from 'moment';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import LoadingIndicator from '../Generics/LoadingIndicator.vue';
import { formattedDate, getValueByType } from '../../../core/utils/date-handlers'
import { UnitLabels, UnitType } from '../../../typescript/values/unitLabels'
@Component({
    components: {
        LoadingIndicator
    }
})
export default class LabelWithValue extends Vue {
    @Prop({default: ''}) label: string;
    @Prop({default: ''}) infoText: string;
    @Prop({default: false}) loading: boolean;
    @Prop({default: null}) value: string | null;
    @Prop({default: null}) unit: UnitType;
    @Prop({default: "100"}) minWidth: string;
    @Prop({default: "100"}) valueMinWidth: string;

    get displayValue() {
        const val = this.value;

        // si es null, undefined o un guion, no agregar unidad
        if (val === null || val === undefined || val === '-') {
            return val;
        }

        const unit = this.unit as UnitType | string | null;
        const parsedValue = getValueByType(val, typeof unit === 'string' && (UnitLabels as any)[unit] ? unit : null);

        const unitLabel =
            unit && typeof unit === 'string' && (UnitLabels as any)[unit]
            ? UnitLabels[unit as UnitType]
            : (unit ? String(unit) : '');

        return unitLabel ? `${parsedValue} ${unitLabel}` : parsedValue;
    }

    getValueParsed(value, unit) {
        const parsedValue = getValueByType(value, unit);

        if (unit && UnitLabels[unit]) {
            return `${parsedValue} ${UnitLabels[unit]}`;
        }

        return parsedValue;
        }
    }
